import React, { FC } from 'react'
import { fade, makeStyles } from '@material-ui/core/styles'
import SearchIcon from '@material-ui/icons/Search'
import { Grid, InputAdornment, TextField } from '@material-ui/core'
import LoadingButton from '../buttons/LoadingButton'

const useStyles = makeStyles(theme => ({
  search: {
    position: 'relative',
    borderRadius: theme.shape.borderRadius,
    backgroundColor: fade(theme.palette.common.white, 0.15),
    '&:hover': {
      backgroundColor: fade(theme.palette.common.white, 0.25),
    },
    marginRight: theme.spacing(2),
    marginLeft: 0,
    width: '100%',
    [theme.breakpoints.up('sm')]: {
      marginLeft: theme.spacing(3),
      width: 'auto',
    },
  },
  searchIcon: {
    width: theme.spacing(7),
    height: '100%',
    position: 'absolute',
    pointerEvents: 'none',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  inputRoot: {
    color: 'inherit',
  },
  margin: {
    margin: theme.spacing(1),
  },
  inputInput: {
    padding: theme.spacing(1, 1, 1, 7),
    transition: theme.transitions.create('width'),
    width: '100%',
    [theme.breakpoints.up('md')]: {
      width: 200,
    },
  },
}))

interface Props {
  preGlobalFilteredRows: any,
  globalFilter: any,
  setGlobalFilter: any,
  update: (() => void) | null,
  pending: boolean,
  text: string
}

const GlobalFilter: FC<Props> = ({preGlobalFilteredRows, globalFilter, setGlobalFilter, update, pending, text}) => {
  const classes = useStyles()
  const count = preGlobalFilteredRows.length

  // Global filter only works with pagination from the first page.
  // This may not be a problem for server side pagination when
  // only the current page is downloaded.

  return (
    <Grid
      container
      direction="row"
      justify="flex-start"
      alignItems="center"
      spacing={1}
    >
      <Grid item xs={12} sm={2}>
        {update !== null &&
          // <Button onClick={update} fullWidth variant="contained" color="primary">
          //    Opdater
          // </Button>
          <LoadingButton update={update} text={(text) ? text : "Opdater"} pending={pending}/>
        }
      </Grid>
          <Grid item xs={12} sm={10}>
            <TextField
              fullWidth
              variant="outlined" 
              value={globalFilter || ''}
              onChange={e => {
                setGlobalFilter(e.target.value || undefined) // Set undefined to remove the filter entirely
              }}
              placeholder={`${count} rækker...`}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <SearchIcon />
                  </InputAdornment>
                ),
              }}
              classes={{
                root: classes.inputRoot,
                // input: classes.inputInput,
              }}
              inputProps={{ 'aria-label': 'search' }}
            />
        </Grid>
    </Grid>
  )
}

export default GlobalFilter



